import { IconButton, Stack } from '@fluentui/react'
import React, { useState } from 'react'
import { AccessGroupRow } from '../../list';
import { AccessGroupsViewModal } from '../AccessGroupsViewModal';

interface EditAccessGroupProps {
  accessGroup: AccessGroupRow;
}

export const EditAccessGroup: React.FC<EditAccessGroupProps> = ({
  accessGroup
}) => {
  const [visible, setVisible] = useState(false);
  const {
    _isUpdatable
  } = { ...accessGroup }

  const _onClick = () => {
    setVisible(true)
  }

  return (
    <Stack>
      <IconButton
        iconProps={{ iconName: 'Edit' }}
        onClick={_onClick}
        disabled={!_isUpdatable}
      />
      <AccessGroupsViewModal
        isOpen={visible}
        accessGroup={accessGroup}
        onClose={() => setVisible(false)}
      />
    </Stack>
  )
}
